import { handleActions } from 'redux-actions'

import {
  POINTS_CREATE_CACHE_START,
  POINTS_CREATE_CACHE_SUCCEEDED,
  POINTS_SET_SELECTED_POINT_SUCCEEDED,
  POINTS_SET_SELECTED_POINT_FINALLY,
  POINTS_SET_SELECTED_POINT_START,
  POINTS_SET_POINTS,
  LOGOUT,
} from '../../actions'

const initialState = {
  data: [],
  selected: {},
  cardTitle: '',
  cardItems: [],
  showCard: false,
  loading: false,
  loadingCache: false,
}

export default handleActions({
  [POINTS_SET_POINTS]: (state, action) => ({
    ...state,
    data: action.payload,
  }),
  [POINTS_SET_SELECTED_POINT_START]: (state, action) => ({
    ...state,
    loading: true,
  }),
  [POINTS_SET_SELECTED_POINT_SUCCEEDED]: (state, action) => ({
    ...state,
    selected: action.payload.selected,
    cardTitle: action.payload.cardTitle,
    showCard: action.payload.showCard,
  }),
  [POINTS_SET_SELECTED_POINT_FINALLY]: (state, action) => ({
    ...state,
    loading: false,
  }),
  [POINTS_CREATE_CACHE_START]: (state, action) => ({
    ...state,
    loadingCache: true,
  }),
  [POINTS_CREATE_CACHE_SUCCEEDED]: (state, action) => ({
    ...state,
    loadingCache: false,
  }),
  [LOGOUT]: () => initialState,
}, initialState)
